import React from 'react';

import PopUp from '@/common/components/PopUp';

import ActionButton from '@/common/components/buttons/ActionButton';
import { Wrapper } from './ConsultantRefunds.styles';
import ConsultantRefundsTable from './components/table/ConsultantRefundsTable';
import useConsultantRefunds from './hooks/useConsultantRefunds';
import NewRefund from './components/newRefund/NewRefund';
import Loading from '@/common/components/Loading';
import { createConsultantRefund, findConsultantRefund } from '@/API/repositories/consultantRefunds';
import { useRequestsContext } from '@/common/hooks/requestHook';

const ConsultantRefunds = () => {
	
	const { hasUnfilledRequest } = useRequestsContext();

	const hook = useConsultantRefunds();

	return (
		<>
		{hasUnfilledRequest(
			findConsultantRefund,
			createConsultantRefund
		) && <Loading />}
		
		<Wrapper>
			<ActionButton text="Add new refund" onClick={() => hook.setNewRefund(true)} />
			<ConsultantRefundsTable hook={hook} />
			{hook.newRefund && <PopUp setShow={hook.setNewRefund}><NewRefund hook={hook}/></PopUp>}
		</Wrapper>
		</>
	);
};

export default ConsultantRefunds;
